module.exports = __webpack_public_path__ + "static/media/sundance2.917b26a4.jpg";